// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OrderSummary.module.css */

.OrderSummary_summaryContainer__JRXj2 {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.OrderSummary_container__nMBKf {
  padding: 15px;
}

.OrderSummary_title__CVxQE {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.OrderSummary_divider__EX8Vn {
  border: none;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

.OrderSummary_row__geu5P {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 14px;
  margin-top: 20px;
}

.OrderSummary_row__geu5P span {
  font-size: 17px;
  text-align: right;
  width: 50%;
}

.OrderSummary_totalRow__mfCHc {
}

.OrderSummary_totalRow__mfCHc span {
  font-size: 23px;
  font-weight: bold;
}

.OrderSummary_promoButton__6mamn {
  display: block;
  margin: 10px 0;
  color: red;
  background: none;
  border: none;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}

.OrderSummary_promoButton__6mamn:hover {
  text-decoration: none;
}

.OrderSummary_processContainer__pCpQ9 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
}

.OrderSummary_processButton__41oH9 {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  color: #000; /* Negru */
}

.OrderSummary_processButton__41oH9:hover {
  background-color: #f8f8f8;
  border-color: #ccc;
}

.OrderSummary_promoContainer__\\+0SZo {
  display: flex;
  align-items: center; /* Centrează vertical inputul și butonul */
  width: 100%; /* Ajustează lățimea containerului, dacă este necesar */
  padding: 8px 0;
  justify-content: right;
}

.OrderSummary_input__mDJq3 {
  width: 200px;
  padding: 8px; /* Padding redus pentru o înălțime mai mică */
  border: 1px solid #ccc;
  border-right: none; /* Elimină bordura dreaptă pentru a se lipi de buton */
  border-radius: 4px 0 0 4px; /* Rotunjire pe colțurile stânga */
  font-size: 14px; /* Dimensiunea textului mai mică */
  height: 36px; /* Înălțime redusă */
  box-sizing: border-box; /* Asigură padding corect */
}

.OrderSummary_button__irLc2 {
  padding: 0 15px; /* Reducem padding-ul lateral */
  background: red; /* Gradient modern */
  color: white;
  border: 1px solid red;
  border-radius: 0 4px 4px 0; /* Rotunjire pe colțurile dreapta */
  height: 36px; /* Înălțimea redusă pentru a se potrivi cu inputul */
  font-size: 14px; /* Dimensiune text proporțională */
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease; /* Efect plăcut de hover */
}

.OrderSummary_button__irLc2:hover {
  background: #fff; /* Gradient mai închis */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Umbră mai discretă */
  border: 1px solid red;
  color: red;
}

.OrderSummary_invalidText__Fj\\+B7 {
  padding: 0;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/OrderReview/OrderSummary/OrderSummary.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW,EAAE,UAAU;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,0CAA0C;EAC/D,WAAW,EAAE,uDAAuD;EACpE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY,EAAE,6CAA6C;EAC3D,sBAAsB;EACtB,kBAAkB,EAAE,sDAAsD;EAC1E,0BAA0B,EAAE,kCAAkC;EAC9D,eAAe,EAAE,kCAAkC;EACnD,YAAY,EAAE,oBAAoB;EAClC,sBAAsB,EAAE,2BAA2B;AACrD;;AAEA;EACE,eAAe,EAAE,+BAA+B;EAChD,eAAe,EAAE,oBAAoB;EACrC,YAAY;EACZ,qBAAqB;EACrB,0BAA0B,EAAE,mCAAmC;EAC/D,YAAY,EAAE,oDAAoD;EAClE,eAAe,EAAE,kCAAkC;EACnD,iBAAiB;EACjB,eAAe;EACf,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,gBAAgB,EAAE,wBAAwB;EAC1C,wCAAwC,EAAE,uBAAuB;EACjE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ","sourcesContent":["/* OrderSummary.module.css */\n\n.summaryContainer {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.container {\n  padding: 15px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.divider {\n  border: none;\n  border-top: 1px solid #ddd;\n  margin: 10px 0;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n  font-size: 14px;\n  margin-top: 20px;\n}\n\n.row span {\n  font-size: 17px;\n  text-align: right;\n  width: 50%;\n}\n\n.totalRow {\n}\n\n.totalRow span {\n  font-size: 23px;\n  font-weight: bold;\n}\n\n.promoButton {\n  display: block;\n  margin: 10px 0;\n  color: red;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: center;\n  font-size: 14px;\n}\n\n.promoButton:hover {\n  text-decoration: none;\n}\n\n.processContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.processButton {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n  color: #000; /* Negru */\n}\n\n.processButton:hover {\n  background-color: #f8f8f8;\n  border-color: #ccc;\n}\n\n.promoContainer {\n  display: flex;\n  align-items: center; /* Centrează vertical inputul și butonul */\n  width: 100%; /* Ajustează lățimea containerului, dacă este necesar */\n  padding: 8px 0;\n  justify-content: right;\n}\n\n.input {\n  width: 200px;\n  padding: 8px; /* Padding redus pentru o înălțime mai mică */\n  border: 1px solid #ccc;\n  border-right: none; /* Elimină bordura dreaptă pentru a se lipi de buton */\n  border-radius: 4px 0 0 4px; /* Rotunjire pe colțurile stânga */\n  font-size: 14px; /* Dimensiunea textului mai mică */\n  height: 36px; /* Înălțime redusă */\n  box-sizing: border-box; /* Asigură padding corect */\n}\n\n.button {\n  padding: 0 15px; /* Reducem padding-ul lateral */\n  background: red; /* Gradient modern */\n  color: white;\n  border: 1px solid red;\n  border-radius: 0 4px 4px 0; /* Rotunjire pe colțurile dreapta */\n  height: 36px; /* Înălțimea redusă pentru a se potrivi cu inputul */\n  font-size: 14px; /* Dimensiune text proporțională */\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease; /* Efect plăcut de hover */\n}\n\n.button:hover {\n  background: #fff; /* Gradient mai închis */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Umbră mai discretă */\n  border: 1px solid red;\n  color: red;\n}\n\n.invalidText {\n  padding: 0;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryContainer": `OrderSummary_summaryContainer__JRXj2`,
	"container": `OrderSummary_container__nMBKf`,
	"title": `OrderSummary_title__CVxQE`,
	"divider": `OrderSummary_divider__EX8Vn`,
	"row": `OrderSummary_row__geu5P`,
	"totalRow": `OrderSummary_totalRow__mfCHc`,
	"promoButton": `OrderSummary_promoButton__6mamn`,
	"processContainer": `OrderSummary_processContainer__pCpQ9`,
	"processButton": `OrderSummary_processButton__41oH9`,
	"promoContainer": `OrderSummary_promoContainer__+0SZo`,
	"input": `OrderSummary_input__mDJq3`,
	"button": `OrderSummary_button__irLc2`,
	"invalidText": `OrderSummary_invalidText__Fj+B7`
};
export default ___CSS_LOADER_EXPORT___;
